// Central content for the Free Custom Website Program + positioning.
// Kept in one data module so a future Next.js/SSR migration can import it
// server-side without touching presentation components.

export const FREE_PROGRAM = {
  build: "$0",
  monthly: "$200",
  monthlySuffix: "/month",
  commitment: "6 Months",
  ownership: "Included",
  features: [
    "Fully Custom Website",
    "Mobile Optimization",
    "Contact Forms",
    "Basic SEO Foundation",
    "Secure Hosting",
    "Ongoing Maintenance",
    "Minor Content Updates",
    "Performance Optimization",
    "Technical Support",
  ],
};

export const TRUST_INDICATORS = [
  "Veteran-Owned",
  "Indigenous-Owned",
  "Custom-Built Solutions",
  "Mobile Optimized",
  "SEO-Ready Foundation",
  "Hosting Included",
  "Ownership Transfer",
];

export const HOW_IT_WORKS = [
  { step: 1, title: "Apply", desc: "Apply for your free website consultation." },
  { step: 2, title: "Design & Build", desc: "We design and build your custom website." },
  { step: 3, title: "Launch", desc: "Launch your website with hosting and maintenance included." },
  { step: 4, title: "Ownership Transfer", desc: "After six months, ownership transfers to you." },
  { step: 5, title: "Continue or Move", desc: "Continue month-to-month for hosting and maintenance, or move the website elsewhere." },
];

export const PROBLEM = {
  title: "Most Business Websites Fail",
  subheadline:
    "Most businesses either spend thousands on a custom website or settle for a generic template. At Equinox Systems, we build premium custom websites with no upfront website development cost.",
  options: [
    {
      tag: "Option 1",
      title: "Pay $1,000–$10,000+ upfront",
      desc: "Hire an agency and pay thousands out of pocket before you ever see a single lead — a heavy risk for a growing business.",
    },
    {
      tag: "Option 2",
      title: "Use a cheap template",
      desc: "Settle for a drag-and-drop template that looks like every other business online and quietly turns customers away.",
    },
  ],
  failures: [
    "Generate leads",
    "Improve visibility",
    "Build credibility",
    "Convert visitors into customers",
  ],
};

export const FREE_FAQS = [
  {
    q: "Is the website really free?",
    a: "Yes. There is no upfront website development fee. Clients only pay for hosting, maintenance, support, and updates.",
  },
  {
    q: "Who owns the website?",
    a: "Equinox retains ownership during the initial six-month agreement. Ownership transfers after all required payments are completed.",
  },
  {
    q: "Who owns the domain?",
    a: "The client purchases and owns their domain name. Equinox handles setup and technical configuration.",
  },
  {
    q: "What happens after six months?",
    a: "Ownership transfers to the client and they may continue services month-to-month for $200/month.",
  },
  {
    q: "Can I leave after six months?",
    a: "Yes. You receive ownership of your website and may move hosting providers if desired.",
  },
  {
    q: "Is SEO included?",
    a: "A foundational SEO setup is included. Advanced SEO services are available separately.",
  },
];

// Side-by-side comparison data (Free Program vs Traditional Purchase).
export const COMPARISON = {
  free: {
    name: "Free Custom Website Program",
    price: "$0",
    priceNote: "Website Build",
    monthly: "$200/month",
    commitment: "6-Month Commitment",
    rows: [
      ["Upfront website cost", "$0"],
      ["Monthly hosting & maintenance", "$200/month"],
      ["Minimum commitment", "6 months"],
      ["Fully custom design", "Yes"],
      ["Mobile optimization", "Yes"],
      ["Basic SEO foundation", "Yes"],
      ["Ongoing maintenance & updates", "Yes"],
      ["Ownership", "Transfers after 6 months"],
    ],
  },
  traditional: {
    name: "Traditional Website Purchase",
    price: "From $499",
    priceNote: "One-time build",
    monthly: "Optional hosting from $29/mo",
    commitment: "Immediate Ownership",
    rows: [
      ["Upfront website cost", "$499 – $1,499+"],
      ["Monthly hosting (optional)", "$29 – $99/month"],
      ["Minimum commitment", "None"],
      ["Fully custom design", "Yes"],
      ["Mobile optimization", "Yes"],
      ["Basic SEO foundation", "Yes"],
      ["Ongoing maintenance & updates", "Add-on"],
      ["Ownership", "Immediate"],
    ],
  },
};
